import React from 'react';
import Text from 'ui/Text';
import { BetPriceWrapper, PriceItem } from 'features/Betslip/styled';

const ChangeBetPrice = ({
    prices,
    combinationPrice,
    changePrice,
    className,
}) => {
    return (
        <BetPriceWrapper className={className}>
            {prices.map((price, index) => (
                <PriceItem
                    key={index}
                    active={combinationPrice === price}
                    onClick={() => changePrice(price)}
                >
                    <Text
                        condensed
                        size="x15"
                        color="#333333"
                        padding="0"
                        bold
                        align="center"
                    >
                        {price.toString().replace('.', ',')} kr.
                    </Text>
                </PriceItem>
            ))}
        </BetPriceWrapper>
    );
};

export default ChangeBetPrice;
